import { useEffect, useRef } from "react";
import { BaseModalWrapper, ModalBackdrop } from "./styled";

export const AnchoredModal = ({
  children,
  open,
  onClose,
  className,
  height,
  width,
  top,
  right,
}) => {
  const modalRef = useRef();

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose?.(event);
      }
    };

    if (open) {
      window.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <ModalBackdrop open={open} />
      <BaseModalWrapper
        open={open}
        className={className}
        height={height}
        width={width}
        top={top}
        left="auto"
        right={right}
      >
        <div ref={modalRef}>{children}</div>
      </BaseModalWrapper>
    </>
  );
};
